<div class="card p-0"
     [ngClass]="{
        highlight: highlight,
        editable: editable,
        'deny-drag': denyDrag,
    }">
    @if (!isInitialised) {
        <!-- swap this in with min height to not render content when not in view to resolve performance issue -->
        <div class="card-body p-0">
            <div class="card-placeholder"></div>
        </div>
    } @else {
        <div class="card-body d-flex flex-column gap-1">
            <div class="kanban-header"
                 data-test="kanban-header">
                @if (showAssignee) {
                    <adapt-link-person class="me-2"
                                       [person]="item.assignee"
                                       [imageOnly]="true"></adapt-link-person>
                }
                <adapt-item-link [item]="item"
                                 [showSummary]="true"
                                 [ngClass]="{
                        'flex-grow-1 blurred-summary': blurSensitiveContent && !item.board?.isPublicReadAccess,
                    }"
                                 (itemDialogOpened)="dialogOpened.emit($event)"
                                 (itemDialogClosed)="dialogClosed.emit($event)"></adapt-item-link>
                @if (!inMultipleSelectionMode) {
                    <adapt-item-action-menu class="ms-auto me-n1 action-menu"
                                            [item]="item"
                                            [showOpenOption]="true"
                                            [showColumnMoveOptions]="!!columnItems"
                                            [columnItems]="columnItems"
                                            (itemClosed)="itemSelected.emit(undefined)"
                                            (itemDeleted)="itemSelected.emit(undefined)"
                                            (dialogOpened)="dialogOpened.emit($event)"
                                            (dialogClosed)="dialogClosed.emit($event)"></adapt-item-action-menu>
                }
                @if (inMultipleSelectionMode) {
                    <dx-check-box class="selection-checkbox"
                                  [value]="inMultipleSelection"
                                  (valueChange)="onSelectionChange($any($event))"></dx-check-box>
                }
            </div>
            @if (item.dueDate || (item.labelLocations && item.labelLocations.length > 0) || (item.comments && item.comments.length > 0)) {
                <div class="d-flex flex-row flex-wrap align-items-center row-gap-1 column-gap-2">
                    @if (item.dueDate) {
                        <span class="small"><b>Due</b> {{ item.dueDate | adaptDate }}</span>
                    }
                    <adapt-display-labels [labelLocations]="item.labelLocations"
                                          [class.blurred-labels]="blurSensitiveContent"></adapt-display-labels>
                    @if (item.comments && item.comments.length > 0) {
                        <div adaptTooltip="{{ item.comments.length }} comments"
                             class="ms-auto flex-shrink-0">
                            <span class="fal fa-fw fa-comment-dots"></span>
                            <span>{{ item.comments.length }}</span>
                        </div>
                    }
                </div>
            }
        </div>
        @if (sortedLinks?.length || linkedObjectives.length) {
            <div class="card-footer p-0">
                <div class="d-flex flex-column item-links-section gap-1">
                    @if (linkedObjectives.length) {
                        <small>Linked objectives</small>
                        <adapt-display-linked-objectives [objectives]="linkedObjectives"
                                                         [blurTitle]="blurSensitiveContent"
                                                         [showGroupObjectiveTextSuffix]="false"></adapt-display-linked-objectives>
                    }
                    @if (sortedLinks?.length) {
                        <small>Linked actions</small>
                    }
                    @for (link of sortedLinks; track link) {
                        <adapt-item-link [item]="link.linkedItem"
                                         [showDialogLink]="true"
                                         [showStatus]="true"
                                         [showSummary]="true"
                                         [showPersonImageLink]="true"
                                         [ngClass]="{
                                'flex-grow-1 blurred-summary': blurSensitiveContent && !link.linkedItem?.board?.isPublicReadAccess,
                            }"></adapt-item-link>
                    }
                </div>
            </div>
        }
    }
</div>
